import React from "react"
import { isCDNImage, notErrorImage } from "../Utils/HelpingFunction"
import { IMGUR_THUMBNAIL_TYPE, returnThumbnailUrl } from "../Utils/utiltyHelper"
import { Trans } from "react-i18next"
import { followersCount } from "../Utils/Converter"
import { SUPPORTED_REDUX_FUNCTIONS } from "../Redux/SUPPORTED_REDUX_FUNCTION"
import { SUPPORTED_MODAL_TYPE } from "../Utils/ModalType"
import { useDispatch } from "react-redux"

interface KOL_IG_PREVIEW_TYPE_BASIC {
  avatarUrl: string
  userName: string
}

interface KOL_IG_PREVIEW_TYPE_INSIGHT {
  numOfPosts: number
  numOfFollowers: number
  numOfFollowing: number
  imagesList: string[]
}

type KOL_IG_PREVIEW_TYPE = KOL_IG_PREVIEW_TYPE_BASIC &
  KOL_IG_PREVIEW_TYPE_INSIGHT

type PropsType = KOL_IG_PREVIEW_TYPE

const KOLIGStylePreview: React.FC<PropsType> = ({
  avatarUrl,
  userName,
  numOfPosts,
  numOfFollowing,
  numOfFollowers,
  imagesList,
}) => {
  const dispatch = useDispatch()

  const setViewImageModal = (state: any) => {
    dispatch({
      type: SUPPORTED_REDUX_FUNCTIONS.TOGGLE_MODAL,
      typeOfModal: SUPPORTED_MODAL_TYPE.VIEW_IMAGE_MODAL,
      returnFn: state.returnFn,
      metaData: state.metaData,
    })
  }

  return (
    <>
      <div className="grid grid-cols-4 mb-4">
        <div className="col-span-1">
          <div className="w-16 h-16 rounded-full">
            <img
              alt={userName + " avatar image"}
              className="object-cover w-16 h-16 rounded-full"
              src={returnThumbnailUrl(avatarUrl, IMGUR_THUMBNAIL_TYPE.b)}
            />
          </div>
        </div>
        <div className={"grid grid-cols-3 col-span-3"}>
          <div className={"text-center my-auto"}>
            <div className={"text-lg font-semibold"}>
              {numOfPosts ? numOfPosts : 0}
            </div>
            <span className="text-sm text-gray-500 font-normal">
              <Trans>SignUp.posts</Trans>
            </span>
          </div>
          <div className={"text-center  my-auto"}>
            <div className={"text-lg font-semibold"}>
              {numOfFollowers ? followersCount(numOfFollowers) : 0}
            </div>
            <span className="text-sm text-gray-500 font-normal">
              <Trans>SignUp.followers</Trans>
            </span>
          </div>
          <div className={"text-center  my-auto"}>
            <div className={"text-lg font-semibold"}>
              {numOfFollowing ? numOfFollowing : 0}
            </div>
            <span className="text-sm text-gray-500 font-normal">
              <Trans>SignUp.following</Trans>
            </span>
          </div>
        </div>
      </div>
      {/* KOL images*/}
      <div className="grid gap-2 grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4">
        {Array.isArray(imagesList) &&
          imagesList.map((imageSrc, index) => {
            if (index < 6 && !isCDNImage(imageSrc) && notErrorImage(imageSrc)) {
              return (
                <div
                  className="cursor-pointer"
                  key={"img" + index}
                  onClick={() =>
                    setViewImageModal({
                      returnFn: null,
                      metaData: {
                        imageUrl: imageSrc,
                      },
                    })
                  }>
                  <img
                    src={returnThumbnailUrl(imageSrc)}
                    className="w-full h-40 md:h-32 lg:h-32 xl:h-36 object-cover rounded-md"
                    alt={userName + " cover image " + (index + 1)}
                  />
                </div>
              )
            }
          })}
      </div>
    </>
  )
}
export default KOLIGStylePreview
